module.exports = __webpack_public_path__ + "assets/img/craftIcon1.ce522b04.png";